<section class="status-page">
  <h1 class="number status-page__title">Not Authorized</h1>
  <h2 class="description status-page__description">
    You are not authorized to view the resource requested
  </h2>
  <h3 class="status-page__action">Would you like to go <a href="#/">home</a>?</h3>
</section>
